import React from 'react';

import I18n from 'utils/I18n';
import Cldr from 'utils/Cldr';

import { useCheckoutContext } from '../../state/CheckoutContext';

import Card from '../shared/Card';
import Inset from '../shared/Inset';
import DurationSelect from './DurationSelect';
import PricingList from './PricingList';
import Footer from './Footer';

import styles from './Summary.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.organic';
export const I18nPrefixTrial = 'strava.subscriptions.checkout.summary.trial';
export const I18nPrefixSubscriptionPreview =
  'components.subscription_preview.checkout';

export const Summary = () => {
  const { checkoutEntityState } = useCheckoutContext();
  const {
    duration,
    experiments,
    promoCampaign,
    products
  } = checkoutEntityState;
  const promotionArgument = products?.promotion?.argument;
  const cartData = products?.[duration];
  const { shouldShowSubscriptionPreview } = experiments;

  return (
    <div className={styles.checkoutSummary}>
      <Card>
        {shouldShowSubscriptionPreview && (
          <Inset className={styles.overviewSection}>
            <h4 className={styles.overviewTitle}>
              {I18n.t(`${I18nPrefixSubscriptionPreview}.title`)}
            </h4>
            <p className={styles.overviewDescription}>
              {I18n.t_html(`${I18nPrefixTrial}.description`)}
            </p>
          </Inset>
        )}
        {promoCampaign ? (
          <Inset>
            <h4 className={styles.promoHeader} data-testid="promo-header">
              {I18n.t(`${I18nPrefix}.membership.${duration}`)}
            </h4>
          </Inset>
        ) : (
          <Inset dataTestId="duration-select">
            <DurationSelect />
          </Inset>
        )}
        <PricingList />

        <Inset className={styles.summaryFooter}>
          <Footer />
        </Inset>

        <Inset className={styles.footnote}>
          {cartData.recurringAmount !== cartData.billedToday &&
            I18n.t(`${I18nPrefix}.price_after_discount_v2.${duration}`, {
              price: Cldr.formatCurrency(
                cartData.recurringAmount,
                cartData.currency
              ),
              count: promotionArgument
            })}{' '}
          {I18n.t(`${I18nPrefix}.cancel`)}
        </Inset>
      </Card>
    </div>
  );
};

export default Summary;
